module.exports = __webpack_public_path__ + "static/media/banner.448861f9.jpg";